import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
import UserPage from 'flarum/forum/components/UserPage';
app.initializers.add('val-ui-likes-count', () => {
  extend(UserPage.prototype, 'navItems', function (items) {
    const user = this.user;
    if (!user || !items.has('likes')) return;
    const rawCount = user.attribute('valLikesCount');
    const count = Number.isFinite(Number(rawCount)) ? Number(rawCount) : 0;
    items.setContent('likes', m(LinkButton, {
      href: app.route('user.likes', {
        username: user.slug()
      }),
      icon: 'far fa-thumbs-up'
    }, [app.translator.trans('flarum-likes.forum.user.likes_link'), ' ', m('span.Button-badge', count)]));
  });
}, -100);